const items = [
  "MAGIC: THE GATHERING",
  "POKÉMON BASE SET",
  "SEALED BOOSTER BOXES",
  "GRADED SLABS",
  "AUSTIN · DALLAS · HOUSTON",
  "BUYING IN ALL 50 STATES",
  "DUAL LANDS",
  "CHARIZARD NO.1",
  "VINTAGE MASTER SETS",
  "HIGH-VALUE SINGLES",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-8 font-mono text-xs tracking-[0.3em] text-cream/60">{item}</span>
        <span className="inline-block h-2 w-2 rotate-45 bg-gold/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-gold/20 bg-ink/60 py-4"
    aria-hidden="true"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
